import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Components
import LightsCard from "layouts/components/card/LightsCard";

function LightsEco({ data }) {
  const renderData = data.map(({ title, description, items }) => (
    <Grid container spacing={3} sx={{ mb: 10 }} key={title}>
      {/* 왼쪽 타이틀과 설명 */}
      <Grid
        item
        xs={12}
        sm={3}
        md={3}
        sx={{
          textAlign: { xs: "center", sm: "left" },
          padding: { xs: 1, sm: 2 },
        }}
      >
        <MKBox position="sticky" top="100px" pb={{ xs: 2, md: 6 }}>
          <MKTypography
            variant="h3"
            fontWeight="bold"
            mb={1}
            sx={{
              fontSize: { xs: "1.25rem", sm: "1.5rem", md: "2rem" },
            }}
          >
            {title}
          </MKTypography>
          <MKTypography
            variant="body2"
            fontWeight="regular"
            color="secondary"
            mb={1}
            sx={{
              fontSize: { sx: "0.05rem", sm: "0.8rem", md: "1rem" },
            }}
          >
            {description}
          </MKTypography>
        </MKBox>
      </Grid>

      {/* 오른쪽 카드 영역 */}
      <Grid
        item
        xs={12}
        sm={9}
        md={9}
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: { xs: "center", sm: "flex-start" },
        }}
      >
        <Grid container spacing={2}>
          {items.map(({ id, thumbnails, name, energy, water }) => (
            <Grid
              item
              xs={6} // 모바일에서 2열 배치
              sm={6} // 태블릿에서도 2열 유지
              md={4} // 데스크톱에서 3열
              key={name}
              sx={{
                mb: 3,
                height: { xs: "220px", sm: "300px", md: "400px" }, // 카드 높이 조정
              }}
            >
              <LightsCard
                thumbnails={thumbnails}
                name={name}
                energy={energy}
                water={water}
                productsId={id}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  ));

  return (
    <MKBox component="section" my={6} py={6}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
        >
          <MKTypography
            variant="h2"
            fontWeight="bold"
            sx={{
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
            }}
          >
            조명 제품 목록
          </MKTypography>
          <MKTypography
            variant="body1"
            color="text"
            sx={{
              fontSize: { xs: "0.875rem", sm: "1rem", md: "1.125rem" },
            }}
          >
            다양한 조명을 확인해보세요.
          </MKTypography>
        </Grid>
      </Container>
      <Container sx={{ mt: 6 }}>{renderData}</Container>
    </MKBox>
  );
}

LightsEco.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired, // id를 string으로 설정
          thumbnails: PropTypes.arrayOf(PropTypes.string).isRequired,
          name: PropTypes.string.isRequired,
          energy: PropTypes.bool.isRequired,
        })
      ),
    })
  ).isRequired,
};

export default LightsEco;
